<template>
  <div id="WarehouseShippingOptions" class="container warehouse-shipping-options-vue wsov">
    <div class="row">
      <div class="col-md-3 col-sm-12">
        <MyAccount />
      </div>
      <div class="col-md-9 col-sm-12">
        <div class="col-md-12 warehouseShippingTitle">
          <h1>{{ getContentItem("warehouseShippingOptionsMenu") }}</h1>
        </div>
        <div class="row">
          <div class="col-md-9 pull-left">
            <p class="freightTermsLabel">
              Freight Terms:
              <v-select
                id="freightTermsSelect"
                v-model="freightTermsDefault"
                class="freightTermsSelect"
                :options="freightTerms"
                :select-on-tab="true"
              />
            </p>
          </div>

          <div class="col-md-3 pull-right">
            <DnFunctionButton
              id="frieghtTermsSaveButton"
              :callback-fn="SaveWareHouseShippingOptions"
              :text="getContentItem('save')"
              :size="largeSize"
            />
          </div>
        </div>
        <div class="warehouseShippingTabsWrapper">
          <div id="warehouseShippingTabs" class="warehouseShippingTabContainer">
            <div id="WarehouseTabs" class="warehouseShippingTabs">
              <a
                v-for="( tabToDisplay, warehouseTabsKey ) in facingWarehouse"
                :key="warehouseTabsKey"
                :class="[ warehouseCode === tabToDisplay ? 'active' : '' ]"
                @click="HandleActiveTabEvents(tabToDisplay)"
              >{{ warehouseShippingTabs[tabToDisplay] }}</a>
              <a
                :class="[ warehouseCode === 'GRR' ? 'active' : '' ]"
                @click="HandleActiveTabEvents('GRR')"
              >
                GRAND RAPIDS, MI / MARENGO, IL
              </a>
              <a
                v-if="IsMcfa"
                :class="[ warehouseCode === 'ThirdParty' ? 'active' : '' ]"
                @click="HandleActiveTabEvents('ThirdParty')"
              >3RD PARTY</a>
            </div>
            <div id="WarehouseTabContent">
              <div class="warehouseShippingContent">
                <div v-if="warehouseCode !== 'ThirdParty'" class="warehouseShippingTabContent">
                  <WarehouseTabContent
                    :current-tab-content-summary="shipperSummary"
                    :dirty-warehouse-shipping-tab-content="dirtyWarehouseShippingData"
                  />
                </div>
                <div v-else class="warehouseShippingTabContent">
                  <div class="alert alert-block alert-info mt-2">
                    <p class="alertTextStyle">
                      {{ getContentItem("enterDefaultAccountNumbers") }}
                    </p>
                  </div>
                  <div
                    v-for="(thirdParty, thirdPartyKey) in thirdPartyAccountDetails.Items"
                    id="defaultAccountNumbers"
                    :key="thirdPartyKey"
                    class="defaultAccountNumbers"
                  >
                    <div class="control-group">
                      <label class="control-label">{{ thirdParty.CarrierDescription }}</label>
                      <span>
                        <input
                          id="UPS"
                          v-model="thirdParty.AccountNumber"
                          class="warehouseShippingDefaultInput"
                          type="text"
                        >
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="userIsWebDeveloper" class="wsov__bulk-update">
          <h4 class="wsov__bulk-update-title">Bulk Update</h4>
          <span>Enter Dealer Codes:</span>
          <textarea class="wsov__bulk-update-text-area" v-model="bulkUpdateDealerCodes"></textarea>
          <br/>
          <DnFunctionButton
              id="bulkUpdateShippingOptionsButton"
              :callback-fn="BulkUpdateWarehouseShippingOptions"
              text="Save Shipping Options"
              :size="largeSize"
            />
            <DnFunctionButton
              id="bulkUpdateDefaultFreightTermsButton"
              :callback-fn="BulkUpdateDefaultFreightTerms"
              text="Save Default Freight Terms"
              :size="largeSize"
            />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import vSelect from "vue-select";
  import MyAccount from "@/components/SubMenus/MyAccount";
  import { WarehouseShippingOptionsService } from "@/services/WarehouseShippingOptionsService";
  import WarehouseTabContent from "./WarehouseTabContent";
  import { ErrorLogService } from "@/services/ErrorLogService";
  import DnFunctionButton from "@/components/Elements/DnFunctionButton";
  import { sizeHelper } from "@/components/mixins/sizeHelper";
  import { constants } from "@/const"
  import { FeatureFlagService } from "@/services/FeatureFlagService"

  export default {
    components: {
      MyAccount,
      vSelect,
      WarehouseTabContent,
      DnFunctionButton,
    },
    mixins: [sizeHelper],
    data: () => ({
      warehouseShippingSummary: {},
      warehouseCode: "",  
      freightTerms: [],
      bulkUpdateDealerCodes: "",
      freightTermsDefault: "",
      thirdPartyAccountDetails: {},
      warehouseShippingTabs: {
        IN: "INDIANAPOLIS, IN",
        YO: "PITTSTON, PA",
        PA: "PITTSTON, PA",
        ON: "ONTARIO, CA",
        CA: "ONTARIO, CA",
        TX: "DALLAS, TX",
        BE: "PUURS",
        CEW: "ENSCHEDE",
        SI: "SINGAPORE",
        JP: "JAPAN",
        GRR: "GRAND RAPIDS, MI / MARENGO, IL",
        ThirdParty: "3RD PARTY",
      },
      dirtyWarehouseShippingData: {
        SelectedWarehouseShippingOptions: [],
        ThirdPartyShipping: {},
      },
      shipperSummary: [
        { ShippingMethodCode: "LOADING - -" }, // displays "LOADING" just before data loads on page.
      ],
      warehouseTabsLoaded: [],
    }),
    computed: {
      ...mapGetters([
        "user",
        "getContentItem",
        "IsMcfa",
        "IsMcfe",
        "IsMcfs",
        "activeAccountId",
        "facingWarehouse",
        "hasPermission"
      ]),
      userIsWebDeveloper: function () {
        return this.hasPermission("IsWebDeveloper")
      },
      showIL01Warehouse(){
        return FeatureFlagService.getFeatureEnabled(constants.FEATURE_NAMES.SHOW_IL_WAREHOUSE);
      }
    },
    created: function() {
      this.SetDefaultWarehouseCode();
      this.GetWarehouseShippingOptions();
      this.GetFreightTerms();
      this.GetFreightTermsDefault();
      this.GetThirdPartyDetails();
    },

    methods: {
      SetDefaultWarehouseCode() {
        // setting default active tab based McfCostCenter
        if (this.IsMcfe) {
          this.warehouseCode = "BE";
        } else if (this.IsMcfs) {
          this.warehouseCode = "SI";
        } else {
          this.warehouseCode = "IN";
        }
      },

      GetWarehouseShippingOptions() {
        // Only call the server and add to the warehouseShippingSummary array
        // if the data has not already been added (per activetab)
        if (!this.warehouseTabsLoaded.includes(this.warehouseCode)) {
          this.LoadShippingOptions(this.activeAccountId, this.user.UserId, 1, this.warehouseCode, true)
            .then((warehouseSummary) => {

              // this initial if statement prevents an undefined error upon inital page load
              if (this.warehouseShippingSummary.length === undefined) {
                this.warehouseShippingSummary = warehouseSummary;

                // data only for the active tab
                this.shipperSummary = warehouseSummary;

                // add the warehouseCode for the current data to warehouseTabLoaded to keep track
                // of which tabs have been loaded
                this.warehouseTabsLoaded.push(warehouseSummary[0].WarehouseCode);
              } else {
                for (var i = 0; i < warehouseSummary.length; i++) {
                  this.warehouseShippingSummary.push(warehouseSummary[i]);
                }

                // data only for the active tab
                this.shipperSummary = warehouseSummary;

                // add the warehouseCode for the current data to warehouseTabLoaded to keep track
                // of which tabs have been loaded
                this.warehouseTabsLoaded.push(warehouseSummary[0].WarehouseCode);
              }
            })
            .catch((err) => {
              ErrorLogService.LogException(err);
            });
        } else {
          // if the tab has been loaded once, get active tab data from warehouseShippingSummary to send
          let filteredDefaults = this.FilterShipper(this.warehouseShippingSummary);
          this.shipperSummary = filteredDefaults;
        }
      },

      LoadShippingOptions(accountId, userId, siteId, warehouseCode, showAll) {
        return WarehouseShippingOptionsService.LoadWarehouseShippingOptions(
          accountId,
          userId,
          siteId,
          warehouseCode,
          showAll,
          true
        );
      },

      GetFreightTerms() {
        WarehouseShippingOptionsService.LoadFreightTermsList()
          .then((freightTermsList) => {
            this.freightTerms = freightTermsList;
          })
          .catch((err) => {
            ErrorLogService.LogException(err);
          });
      },

      GetFreightTermsDefault() {
        // sets default freight terms if one is set
        WarehouseShippingOptionsService.LoadFreightTermsDefault(this.activeAccountId, this.user.UserId)
          .then((defaultFreightTerms) => {
            this.freightTermsDefault = defaultFreightTerms;
          })
          .catch((err) => {
            ErrorLogService.LogException(err);
          });
      },

      GetThirdPartyDetails() {
        WarehouseShippingOptionsService.LoadThirdPartyDetails(this.activeAccountId, this.user.UserId)
          .then((thirdPartyDetails) => {
            this.thirdPartyAccountDetails = thirdPartyDetails;
            this.dirtyWarehouseShippingData.ThirdPartyShipping = this.thirdPartyAccountDetails.Items;
          })
          .catch((err) => {
            ErrorLogService.LogException(err);
          });
      },

      HandleActiveTabEvents(warehouseCode) {
        this.warehouseCode = warehouseCode;
        if (this.warehouseCode != "ThirdParty") {
          this.GetWarehouseShippingOptions();
        }
      },

      BulkUpdateWarehouseShippingOptions(){
        // eslint-disable-next-line no-alert
        if(!confirm("Are you sure you want to bulk update warehouse shipping options?")){
          return;
        }
        //split on new line
        var dealerCodes = this.bulkUpdateDealerCodes.split(/\r?\n/);

        WarehouseShippingOptionsService.BulkUpdateWarehouseShippingOptionsSelections(
          dealerCodes,
          this.dirtyWarehouseShippingData
        ).then((saveSuccessful) => {
          if (saveSuccessful) {
            this.$store.commit("pushTimedMessage", {
              header: "Bulk Warehouse Shipping Options updated successfully.",
              IsError: false,
              seconds: 5,
            });
          } else {
            this.$store.commit("pushTimedMessage", {
              header: "Unable to bulk update Warehouse Shipping Options.",
              IsError: true,
              seconds: 5,
            });
          }
        }).catch((err) => {
          ErrorLogService.LogException(err);
        });
      },

      BulkUpdateDefaultFreightTerms(){
        // eslint-disable-next-line no-alert
        if(!confirm("Are you sure you want to bulk update default freight terms?")){
          return;
        }
        //split on new line
        var dealerCodes = this.bulkUpdateDealerCodes.split(/\r?\n/);

        WarehouseShippingOptionsService.BulkUpdateDefaultFreightTerms(
            dealerCodes,
            this.freightTermsDefault
          )
            .then((saveSuccessful) => {
              if (saveSuccessful) {
                this.$store.commit("pushTimedMessage", {
                  header: "Bulk Default Freight Terms updated successfully.",
                  IsError: false,
                  seconds: 5,
                });
              } else {
                this.$store.commit("pushTimedMessage", {
                  header: "Unable to bulk update Default Freight Terms.",
                  IsError: true,
                  seconds: 5,
                });
              }
            })
            .catch((err) => {
              ErrorLogService.LogException(err);
            });
      },

      UpdateWarehouseShippingOptions() {
        WarehouseShippingOptionsService.UpdateWarehouseShippingOptionsSelections(
          this.activeAccountId,
          this.user.UserId,
          this.dirtyWarehouseShippingData
        )
          .then((saveSuccessful) => {
            if (saveSuccessful) {
              this.$store.commit("pushTimedMessage", {
                header: "Warehouse Shipping Options updated successfully.",
                IsError: false,
                seconds: 5,
              });
            } else {
              this.$store.commit("pushTimedMessage", {
                header: "Unable to update Warehouse Shipping Options.",
                IsError: true,
                seconds: 5,
              });
            }
          })
          .catch((err) => {
            ErrorLogService.LogException(err);
          });
      },

      UpdateFreightTerms() {
        WarehouseShippingOptionsService.SaveFreightTermDefault(
          this.activeAccountId,
          this.user.UserId,
          this.freightTermsDefault
        )
          .then((saveSuccessful) => {
            if (saveSuccessful) {
              this.$store.commit("pushTimedMessage", {
                header: "Freight Terms updated successfully.",
                IsError: false,
                seconds: 5,
              });
            } else {
              this.$store.commit("pushTimedMessage", {
                header: "Unable to update Freight Terms.",
                IsError: true,
                seconds: 5,
              });
            }
          })
          .catch((err) => {
            ErrorLogService.LogException(err);
          });
      },

      SaveWareHouseShippingOptions() {
        this.UpdateWarehouseShippingOptions();
        this.UpdateFreightTerms();
      },

      FilterShipper(shippers) {
        const shippersList = [{}];

        // return only those shippers that match the active tab warehouse code
        for (let i = 0; i < shippers.length; i++) {
          if (shippers[i].WarehouseCode === this.warehouseCode) {
            shippersList.push(shippers[i]);
          }
        }

        // initialation of the array makes the first element blank, this removes it.
        shippersList.splice(0, 1);
        return shippersList;
      },
    },
  };
</script>


<style lang="scss">
.warehouseShippingTabsWrapper {
  padding: 8px 0 20px 0;
}

.warehouseShippingTabContainer {
  margin: 40px auto;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 11px;
  color: #888;
}

.warehouseShippingTabs {
  overflow: hidden;
  margin-bottom: -2px;

  ul {
    list-style-type: none;
    margin-left: 20px;
  }
  a {
    float: left;
    cursor: pointer;
    padding: 8px 12px;
    transition: background-color 0.2s;
    border: 1px solid $light-gray;
    border-right: none;
    background-color: #f1f1f1;
    border-radius: 5px 5px 0 0;
    font-weight: bold;
    &:last-child {
      border-right: 1px solid $light-gray;
    }
    &:hover {
      background-color: #aaa;
      color: #fff;
    }
    &.active {
      background-color: #fff;
      color: #484848;
      border-bottom: 2px solid #fff;
      cursor: default;
    }

    .warehouseShippingDefaultInput {
      border: 1px solid $light-gray;
      border-radius: 3px;
      padding: 4px;
      width: 250px;
    }

  }
}

.wsov__bulk-update{
  padding: 12px;
  border: 1px solid black;
}
.wsov__bulk-update-text-area{
  width: 100%;
}
</style>